import { render, staticRenderFns } from "./Singup.vue?vue&type=template&id=f5bca8b8&scoped=true&"
import script from "./Singup.vue?vue&type=script&lang=js&"
export * from "./Singup.vue?vue&type=script&lang=js&"
import style0 from "./Singup.vue?vue&type=style&index=0&id=f5bca8b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bca8b8",
  null
  
)

component.options.__file = "Singup.vue"
export default component.exports